module.exports = __webpack_public_path__ + "img/geo-zone_map.372ebc93.svg";